export enum EClaimsGroup {
  aceAi = 'AceAi',
  integration = 'Integration',
  workOrders = 'WorkOrder',
  dashboard = 'Exago',
  account = 'Account',
  aceInsights = 'ACEInsights',
  conversations = 'Conversations',
  leaseHawk = 'LeaseHawk',
  aiAssistant = 'AIAssistant',
  none = 'N/A',
}

export const enum EClaimOperation {
  read = 'Read',
  delete = 'Delete',
  update = 'Update',
  create = 'Create',
  execute = 'Execute',
}

export const UNNORMALIZED_ADMIN_ACCOUNT_CLAIMS = {
  SiteCreate: `Site:${EClaimOperation.create}`,
  SiteRead: `Site:${EClaimOperation.read}`,
  SiteUpdate: `Site:${EClaimOperation.update}`,
  SiteDelete: `Site:${EClaimOperation.delete}`,
  SiteExecute: `Site:${EClaimOperation.execute}`,
};

export const UNNORMALIZED_CONVERSATIONS_ACE_INSIGHTS_CLAIMS = {
  ExternalUserCreate: `ExternalUser:${EClaimOperation.create}`,
  ExternalUserRead: `ExternalUser:${EClaimOperation.read}`,
  ExternalUserUpdate: `ExternalUser:${EClaimOperation.update}`,
  ExternalUserDelete: `ExternalUser:${EClaimOperation.delete}`,
};

export const ADMIN_CLAIMS = {
  aceAiGeneralRead: `${EClaimsGroup.aceAi}General:${EClaimOperation.read}`,
  aceAiGeneralCreate: `${EClaimsGroup.aceAi}General:${EClaimOperation.create}`,
  aceAiGeneralUpdate: `${EClaimsGroup.aceAi}General:${EClaimOperation.update}`,

  aceAiPricingAvailabilityRead: `${EClaimsGroup.aceAi}PricingAvailability:${EClaimOperation.read}`,
  aceAiPricingAvailabilityCreate: `${EClaimsGroup.aceAi}PricingAvailability:${EClaimOperation.create}`,
  aceAiPricingAvailabilityUpdate: `${EClaimsGroup.aceAi}PricingAvailability:${EClaimOperation.update}`,

  aceAiScheduleTourRead: `${EClaimsGroup.aceAi}ScheduleTour:${EClaimOperation.read}`,
  aceAiScheduleTourCreate: `${EClaimsGroup.aceAi}ScheduleTour:${EClaimOperation.create}`,
  aceAiScheduleTourUpdate: `${EClaimsGroup.aceAi}ScheduleTour:${EClaimOperation.update}`,

  aceAiLeasingQuestionsRead: `${EClaimsGroup.aceAi}LeasingQuestions:${EClaimOperation.read}`,
  aceAiLeasingQuestionsCreate: `${EClaimsGroup.aceAi}LeasingQuestions:${EClaimOperation.create}`,
  aceAiLeasingQuestionsUpdate: `${EClaimsGroup.aceAi}LeasingQuestions:${EClaimOperation.update}`,

  aceAiResidentQuestionsRead: `${EClaimsGroup.aceAi}ResidentQuestions:${EClaimOperation.read}`,
  aceAiResidentQuestionsCreate: `${EClaimsGroup.aceAi}ResidentQuestions:${EClaimOperation.create}`,
  aceAiResidentQuestionsUpdate: `${EClaimsGroup.aceAi}ResidentQuestions:${EClaimOperation.update}`,

  aceAiSystemResponsesRead: `${EClaimsGroup.aceAi}SystemResponses:${EClaimOperation.read}`,
  aceAiSystemResponsesCreate: `${EClaimsGroup.aceAi}SystemResponses:${EClaimOperation.create}`,
  aceAiSystemResponsesUpdate: `${EClaimsGroup.aceAi}SystemResponses:${EClaimOperation.update}`,

  aceAiChatbotRead: `${EClaimsGroup.aceAi}Chatbot:${EClaimOperation.read}`,
  aceAiChatbotCreate: `${EClaimsGroup.aceAi}Chatbot:${EClaimOperation.create}`,
  aceAiChatbotUpdate: `${EClaimsGroup.aceAi}Chatbot:${EClaimOperation.update}`,

  aceAiChatbotSandboxCreate: `${EClaimsGroup.aceAi}ChatbotSandbox:${EClaimOperation.create}`,
  aceAiChatbotSandboxRead: `${EClaimsGroup.aceAi}ChatbotSandbox:${EClaimOperation.read}`,
  aceAiChatbotSandboxUpdate: `${EClaimsGroup.aceAi}ChatbotSandbox:${EClaimOperation.update}`,
  aceAiChatbotSandboxDelete: `${EClaimsGroup.aceAi}ChatbotSandbox:${EClaimOperation.delete}`,

  aceAiRulesCreate: `${EClaimsGroup.aceAi}Rules:${EClaimOperation.create}`,
  aceAiRulesRead: `${EClaimsGroup.aceAi}Rules:${EClaimOperation.read}`,
  aceAiRulesUpdate: `${EClaimsGroup.aceAi}Rules:${EClaimOperation.update}`,
  aceAiRulesDelete: `${EClaimsGroup.aceAi}Rules:${EClaimOperation.delete}`,

  adSourceMappingCreate: `${EClaimsGroup.integration}AdSourceMapping:${EClaimOperation.create}`,
  adSourceMappingRead: `${EClaimsGroup.integration}AdSourceMapping:${EClaimOperation.read}`,
  adSourceMappingUpdate: `${EClaimsGroup.integration}AdSourceMapping:${EClaimOperation.update}`,
  adSourceMappingDelete: `${EClaimsGroup.integration}AdSourceMapping:${EClaimOperation.delete}`,

  partnerIntegrationCreate: `${EClaimsGroup.integration}PartnerConfiguration:${EClaimOperation.create}`,
  partnerIntegrationRead: `${EClaimsGroup.integration}PartnerConfiguration:${EClaimOperation.read}`,
  partnerIntegrationUpdate: `${EClaimsGroup.integration}PartnerConfiguration:${EClaimOperation.update}`,
  partnerIntegrationDelete: `${EClaimsGroup.integration}PartnerConfiguration:${EClaimOperation.delete}`,

  aceAiSystemSettingsRead: `${EClaimsGroup.aceAi}SystemSettings:${EClaimOperation.read}`,
  aceAiSystemSettingsUpdate: `${EClaimsGroup.aceAi}SystemSettings:${EClaimOperation.update}`,

  AceAiWorkOrderCaptureCreate: `${EClaimsGroup.aceAi}WorkOrderCapture:${EClaimOperation.create}`,
  AceAiWorkOrderCaptureRead: `${EClaimsGroup.aceAi}WorkOrderCapture:${EClaimOperation.read}`,
  AceAiWorkOrderCaptureUpdate: `${EClaimsGroup.aceAi}WorkOrderCapture:${EClaimOperation.update}`,
  AceAiWorkOrderCaptureDelete: `${EClaimsGroup.aceAi}WorkOrderCapture:${EClaimOperation.delete}`,

  WorkOrdersSystemSettingsCreate: `${EClaimsGroup.workOrders}SystemSettings:${EClaimOperation.create}`,
  WorkOrdersSystemSettingsRead: `${EClaimsGroup.workOrders}SystemSettings:${EClaimOperation.read}`,
  WorkOrdersSystemSettingsUpdate: `${EClaimsGroup.workOrders}SystemSettings:${EClaimOperation.update}`,
  WorkOrdersSystemSettingsDelete: `${EClaimsGroup.workOrders}SystemSettings:${EClaimOperation.delete}`,

  WorkOrderFormSettingsCreate: `${EClaimsGroup.workOrders}FormSettings:${EClaimOperation.create}`,
  WorkOrderFormSettingsRead: `${EClaimsGroup.workOrders}FormSettings:${EClaimOperation.read}`,
  WorkOrderFormSettingsUpdate: `${EClaimsGroup.workOrders}FormSettings:${EClaimOperation.update}`,
  WorkOrderFormSettingsDelete: `${EClaimsGroup.workOrders}FormSettings:${EClaimOperation.delete}`,

  WorkOrderFormStylingCreate: `${EClaimsGroup.workOrders}FormStyling:${EClaimOperation.create}`,
  WorkOrderFormStylingRead: `${EClaimsGroup.workOrders}FormStyling:${EClaimOperation.read}`,
  WorkOrderFormStylingUpdate: `${EClaimsGroup.workOrders}FormStyling:${EClaimOperation.update}`,
  WorkOrderFormStylingDelete: `${EClaimsGroup.workOrders}FormStyling:${EClaimOperation.delete}`,

  AceAiPropertyVariablesCreate: `${EClaimsGroup.aceAi}PropertyVariables:${EClaimOperation.create}`,
  AceAiPropertyVariablesRead: `${EClaimsGroup.aceAi}PropertyVariables:${EClaimOperation.read}`,
  AceAiPropertyVariablesUpdate: `${EClaimsGroup.aceAi}PropertyVariables:${EClaimOperation.update}`,
  AceAiPropertyVariablesDelete: `${EClaimsGroup.aceAi}PropertyVariables:${EClaimOperation.delete}`,

  AccountSiteCreate: `${EClaimsGroup.account}Site:${EClaimOperation.create}`,
  AccountSiteRead: `${EClaimsGroup.account}Site:${EClaimOperation.read}`,
  AccountSiteUpdate: `${EClaimsGroup.account}Site:${EClaimOperation.update}`,
  AccountSiteDelete: `${EClaimsGroup.account}Site:${EClaimOperation.delete}`,
  AccountSiteExecute: `${EClaimsGroup.account}Site:${EClaimOperation.execute}`,

  AccountUserManagementCreate: `${EClaimsGroup.account}UserManagement:${EClaimOperation.create}`,
  AccountUserManagementRead: `${EClaimsGroup.account}UserManagement:${EClaimOperation.read}`,
  AccountUserManagementUpdate: `${EClaimsGroup.account}UserManagement:${EClaimOperation.update}`,
  AccountUserManagementDelete: `${EClaimsGroup.account}UserManagement:${EClaimOperation.delete}`,
};

export const EXAGO_CLAIMS = {
  exagoAllAccessRead: `${EClaimsGroup.dashboard}AllAccess:${EClaimOperation.read}`, // :Read is not necessary (internal usage)
};

export const CALENDAR_CLAIMS = {
  calendarAllAccessRead: `${EClaimsGroup.leaseHawk}Calendar:${EClaimOperation.read}`,
};

export const ACE_INSIGHTS_CLAIMS: Record<string, string> = {
  ACEInsightsScorecardChallengesCreate: `${EClaimsGroup.aceInsights}ScorecardChallengesReview:${EClaimOperation.create}`,
  ACEInsightsScorecardChallengesRead: `${EClaimsGroup.aceInsights}ScorecardChallengesReview:${EClaimOperation.read}`,
  ACEInsightsScorecardChallengesUpdate: `${EClaimsGroup.aceInsights}ScorecardChallengesReview:${EClaimOperation.update}`,
  ACEInsightsScorecardChallengesDelete: `${EClaimsGroup.aceInsights}ScorecardChallengesReview:${EClaimOperation.delete}`,

  ACEInsightsScorecardAdminCreate: `${EClaimsGroup.aceInsights}ScorecardAdmin:${EClaimOperation.create}`,
  ACEInsightsScorecardAdminRead: `${EClaimsGroup.aceInsights}ScorecardAdmin:${EClaimOperation.read}`,
  ACEInsightsScorecardAdminUpdate: `${EClaimsGroup.aceInsights}ScorecardAdmin:${EClaimOperation.update}`,
  ACEInsightsScorecardAdminDelete: `${EClaimsGroup.aceInsights}ScorecardAdmin:${EClaimOperation.delete}`,

  ACEInsightsConversationInsightsRulesCreate: `${EClaimsGroup.aceInsights}ConversationInsightsRules:${EClaimOperation.create}`,
  ACEInsightsConversationInsightsRulesRead: `${EClaimsGroup.aceInsights}ConversationInsightsRules:${EClaimOperation.read}`,
  ACEInsightsConversationInsightsRulesUpdate: `${EClaimsGroup.aceInsights}ConversationInsightsRules:${EClaimOperation.update}`,
  ACEInsightsConversationInsightsRulesDelete: `${EClaimsGroup.aceInsights}ConversationInsightsRules:${EClaimOperation.delete}`,

  ACEInsightsExternalUserCreate: `${EClaimsGroup.aceInsights}ExternalUser:${EClaimOperation.create}`,
  ACEInsightsExternalUserRead: `${EClaimsGroup.aceInsights}ExternalUser:${EClaimOperation.read}`,
  ACEInsightsExternalUserUpdate: `${EClaimsGroup.aceInsights}ExternalUser:${EClaimOperation.update}`,
  ACEInsightsExternalUserDelete: `${EClaimsGroup.aceInsights}ExternalUser:${EClaimOperation.delete}`,

  ConversationsViewerAdminCreate: `${EClaimsGroup.conversations}ViewerAdmin:${EClaimOperation.create}`,
  ConversationsViewerAdminRead: `${EClaimsGroup.conversations}ViewerAdmin:${EClaimOperation.read}`,
  ConversationsViewerAdminUpdate: `${EClaimsGroup.conversations}ViewerAdmin:${EClaimOperation.update}`,
  ConversationsViewerAdminDelete: `${EClaimsGroup.conversations}ViewerAdmin:${EClaimOperation.delete}`,

  ACEInsightsPretrainedQuestionsCreate: `${EClaimsGroup.aceInsights}APPretrainedQuestionsSystemAdmin:${EClaimOperation.create}`,
  ACEInsightsPretrainedQuestionsRead: `${EClaimsGroup.aceInsights}APPretrainedQuestionsSystemAdmin:${EClaimOperation.read}`,
  ACEInsightsPretrainedQuestionsUpdate: `${EClaimsGroup.aceInsights}APPretrainedQuestionsSystemAdmin:${EClaimOperation.update}`,
  ACEInsightsPretrainedQuestionsDelete: `${EClaimsGroup.aceInsights}APPretrainedQuestionsSystemAdmin:${EClaimOperation.delete}`,

  ACEInsightsCISystemRulesCreate: `${EClaimsGroup.aceInsights}CIRulesSystemAdmin:${EClaimOperation.create}`,
  ACEInsightsCISystemRulesRead: `${EClaimsGroup.aceInsights}CIRulesSystemAdmin:${EClaimOperation.read}`,
  ACEInsightsCISystemRulesUpdate: `${EClaimsGroup.aceInsights}CIRulesSystemAdmin:${EClaimOperation.update}`,
  ACEInsightsCISystemRulesDelete: `${EClaimsGroup.aceInsights}CIRulesSystemAdmin:${EClaimOperation.delete}`,
};

export const AI_ASSISTANT_CLAIMS: Record<string, string> = {
  knowledgeBaseRead: `${EClaimsGroup.aiAssistant}KnowledgeBase:${EClaimOperation.read}`,
  priceAndAvailabilityRead: `${EClaimsGroup.aiAssistant}PriceAndAvailabilitySettings:${EClaimOperation.read}`,
};

export type TApplicationClaimMapKey = 'admin' | 'dashboard' | 'reporting' | 'calendar' | 'aceInsights' | 'aiAssistant';

export const APPLICATION_CLAIMS: Record<TApplicationClaimMapKey, Record<string, string>> = {
  admin: ADMIN_CLAIMS,
  reporting: EXAGO_CLAIMS,
  dashboard: EXAGO_CLAIMS,
  calendar: CALENDAR_CLAIMS,
  aceInsights: ACE_INSIGHTS_CLAIMS,
  aiAssistant: AI_ASSISTANT_CLAIMS,
};

export const getApplicationClaims = (): Record<string, string> => {
  const res = {};
  for (const key in APPLICATION_CLAIMS) {
    Object.assign(res, APPLICATION_CLAIMS[key as TApplicationClaimMapKey]);
  }
  return res;
};
